import { LoanReportingSettings } from '@/modules/global-settings/loan-origination/services/loan-policies/loan-reporting-settings.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Instantiate the service
const loanReportingSettings = new LoanReportingSettings();
// Define the state
export const state = {
  categories: []
};
// Define the mutations
export const mutations = {
  ...make.mutations(state)
};
// Define the actions
export const actions = {
  /**
   * Fetch all loan report categories
   * @async
   * @param {object} context - The store context
   * @returns {Array} - The loan report categories
   * @private This will update the state with the fetched loan report categories
   */
  getAll: async ({ commit }) => {
    try {
      const { data } = await loanReportingSettings.getAll();
      commit('SET_CATEGORIES', data);
      return data;
    } catch (error) {
      Logger.error('getting loan report categories', error);
      throw error;
    }
  },
  /**
   * Create a loan report category
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The loan report category payload
   * @returns {object} - The created loan report category
   * @private This will re-fetch the loan report categories
   */
  create: async ({ dispatch }, payload) => {
    try {
      const { data } = await loanReportingSettings.create(payload);
      dispatch('getAll');
      return data;
    } catch (error) {
      Logger.error('creating loan report category', error);
      throw error;
    }
  },
  /**
   * Update a loan report category
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The loan report category payload
   * @returns {void}
   * @private This will re-fetch the loan report categories
   */
  update: async ({ dispatch }, payload) => {
    try {
      await loanReportingSettings.update(payload);
      dispatch('getAll');
    } catch (error) {
      Logger.error('updating loan report categories', error);
      throw error;
    }
  },
  /**
   * Remove a loan report category
   * @async
   * @param {object} context - The store context
   * @param {string} id - The loan report category id
   * @returns {void}
   * @private This will re-fetch the loan report categories
   */
  remove: async ({ dispatch }, id) => {
    try {
      await loanReportingSettings.remove(id);
      dispatch('getAll');
    } catch (error) {
      Logger.error('removing loan report categories', error);
      throw error;
    }
  }
};
// Define the getters
export const getters = make.getters(state);
